import React, { Component } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { bool, func, node, string } from 'prop-types';

class LimitsListItem extends Component {
  static propTypes = {
    active: bool.isRequired,
    onClick: func.isRequired,
    limit: node.isRequired,
    language: string.isRequired,
  };

  static defaultProps = {
    active: false,
  };

  handleClick = (e) => {
    e.preventDefault();
    this.props.onClick(this.props.limit);
  };

  renderLimitLabel = () => {
    const { limit } = this.props;
    if (limit === 'All') {
      return <FormattedMessage id="offers.limits.all" defaultMessage="All" />;
    }
    return limit;
  };

  render() {
    const { active } = this.props;
    return (
      <li className={cn('limits-list-item', { active })}>
        <a onClick={this.handleClick}>{this.renderLimitLabel()}</a>
      </li>
    );
  }
}

const mapStateToProps = ({
  webmaster: {
    profile: { language },
  },
}) => ({ language });

export default connect(mapStateToProps)(LimitsListItem);
